import { callBackendApi } from "../../../../../components/service/axios";

export const fetchReviewedAccesses = async (userId) => {
  return await callBackendApi("get", "/bff/reviewed-accesses", null, {
    userId: userId,
  });
};
